import {
  createComponentPreviewMapperModel,
  withCompInfo,
} from '@wix/editor-elements-integrations';
import { texts } from './constants.preview';
import type { FreemiumBannerOdeditorMapperProps } from '../FreemiumBannerOdeditor.types';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';

export const props = withCompInfo<FreemiumBannerOdeditorMapperProps, any>()(
  ['direction', 'metaSiteId', 'translate', 'experiments'],
  ({ direction, metaSiteId, translate, experiments }) => {
    const href = `https://manage.wix.com/premium-purchase-plan/dynamo?siteGuid=${metaSiteId}&referralAdditionalInfo=editor3_PREVIEW_FREE_SITE_BANNER_UPGRADE_NOW`;
    const heightSpec = 'specs.thunderbolt.FreemiumBannerOdeditorNewHeight';
    const shouldUseUpdatedHeight = isExperimentOpen(experiments, heightSpec);

    return {
      direction,
      textBeforeLogo:
        translate(texts.NAMESPACE, texts.MAIN_TEXT_KEY) ||
        texts.MAIN_TEXT_DEFAULT,
      buttonText:
        translate(texts.NAMESPACE, texts.BUTTON_TEXT_KEY) ||
        texts.BUTTON_TEXT_DEFAULT,
      href,
      shouldUseUpdatedHeight,
      msid: metaSiteId,
    };
  },
);

export default createComponentPreviewMapperModel({ props });
